import logoImg from "../../../assets/images/screenup-ui.svg";

const WelcomeHeader = () => {
  return (
    <div className="flex flex-row m-0 z-10">
      <img
        src={logoImg}
        alt="screenup logo"
        style={{ height: "20px", width: "auto" }}
      />
    </div>
  );
};

export default WelcomeHeader;
